import React, {Fragment} from "react";
import PropTypes from "prop-types";
import SpinnerDiv from "root/Components/SpinnerDiv";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";

import {
    defaultTableHeaderStyles,
    defaultPaginationOptions,
    customHeaderStyle, defaultTopLeftCellStyle, defaultTopRightCellStyle,
    TableActionIconDelete, TableActionIconEdit, TableActionIconView, TableActionIconAdd, TableActionIconManage
} from "./BaseTableComponents";

import './Table.scss'

const OrganisationTable = (props) =>
{
    const onClickItem = (organisation_id, mode) =>
    {
        props.clickHandler(organisation_id, mode);
    }

    const linkFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        return (
            <Fragment>
                <TableActionIconDelete text="Delete Organisation" onClick={() => onClickItem(row.organisation_id, 'delete')} />
                <TableActionIconEdit text="Edit Organisation Details" onClick={() => onClickItem(row.organisation_id, 'edit')} />
                <TableActionIconAdd text="Add Team" onClick={() => onClickItem(row.organisation_id, 'team')} />
            </Fragment>
        );
    }

    const leftHeaderStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        name: {borderRadius: defaultTopLeftCellStyle, width: "12vw"},
        description: {width: "10vw"},
        email: {width: "10vw"},
        phone: {width: "10vw"},
        view: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "6vw"}
    });

    const getColumns = () => {
        const columns = [
            {
                dataField: "name",
                text: "Name",
                sort: true,
                headerStyle: leftHeaderStyle
            },
            {
                dataField: "description",
                text: "Description",
                headerStyle: leftHeaderStyle
            },
            {
                dataField: "email",
                text: "Email",
                headerStyle: leftHeaderStyle
            },
            {
                dataField: "phone",
                text: "Phone",
                headerStyle: leftHeaderStyle
            },
            {
                dataField: "view",
                formatter: linkFormatter,
                align: 'right',
                text: "Manage",
                headerStyle: leftHeaderStyle
            },
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns(getColumns());
    const columns = React.useMemo(() => translations, []);

    const thisTableContent = () =>
    {
        return <PassportTable data={props.data} columns={columns} pagination={defaultPaginationOptions}/>
    }

    return props.loading === true ? <SpinnerDiv/> : thisTableContent();
    };

export default OrganisationTable;

OrganisationTable.propTypes = {
    family_id: PropTypes.string,
    data: PropTypes.array,
    loading: PropTypes.bool
};